import DTOClaveNomina from '../../DTO/DTOClaveNomina';
import http from '../common/http-common';
import AdjuntoResponse from '../../DTO/AdjuntoResponse';
import DTOPeriodoCerrado from '../../DTO/DTOPeriodoCerrado';
import DTOObservacionRH from '../../DTO/Reportes/DTOObservacionRH';

class NominaServices {



    GetCatClavesNomina() {
    return http.get<DTOClaveNomina[]>(`/Catalogos/CatNomina/GetCatClavesNomina`);
    }

    MantenimientoCatClave(data: DTOClaveNomina, accion: 'INSERT' | 'UPDATE' | 'DELETE') {
        return http.post(`/Catalogos/CatNomina/MantenimientoCatClave?accion=${accion}`, data);
    }


    MantenimientoAjusteManual(data: any) {
        
        return http.post(`/Catalogos/CatNomina/GuardarAjusteManual`, data);
    }
    MantenimientoObservacionSemanal(data: any) {
        return http.post(`/Catalogos/CatNomina/MantenimientoObservacionSemanal`, data);
    }


    MantenimientoObservacionRH(payload: any) {
        return http.post('/Catalogos/CatNomina/MantenimientoObservacionRH', payload);
    }

    ObtenerObservacionesRH(fechaInicio: string, fechaFin: string) {
        return http.get<DTOObservacionRH[]>('/Catalogos/CatNomina/ObtenerObservacionesRH', {
            params: { fechaInicio, fechaFin }
        });
    }


    saveComprobanteHE(data: FormData) {
        return http.post('/Catalogos/CatNomina/SaveComprobanteHE', data, {
            headers: {
                'Content-Type': 'multipart/form-data' // Opcional, pero ayuda a asegurar el envío
            }
        });
    }

    getComprobanteHEUrl(numEmpleado: string, fecha: string) {
        // IMPORTANTE: numEmpleado debe ser string para evitar problemas de formato
        const v = new Date().getTime(); // Anti-caché
        return `${http.defaults.baseURL}/Catalogos/CatNomina/GetComprobanteHE/${numEmpleado}/${fecha}?v=${v}`;
    }





    subirAdjunto(formData: FormData) {
        return http.post(`/Catalogos/CatNomina/SubirAdjunto`, formData, {
            headers: {
                // MUY IMPORTANTE: No pongas Content-Type aquí. 
                // Axios lo detectará automáticamente al ver el FormData.
                'Content-Type': 'multipart/form-data' 
            }
        });
    }


    listarAdjuntos(numEmpleado: string, fechaInicio: string) {
        return http.get<AdjuntoResponse[]>(
            `/Catalogos/CatNomina/ListarAdjuntos/${numEmpleado}/${fechaInicio}`
        );
    }


    abrirAdjunto(id: string) {
        const baseUrl = http.defaults.baseURL || '';
        window.open(`${baseUrl}/Catalogos/CatNomina/DescargarAdjunto/${id}`, '_blank');
    }

    verAdjuntoInline(id: string) {
        const baseUrl = http.defaults.baseURL || '';
        const url = `${baseUrl}/Catalogos/CatNomina/DescargarAdjunto/${id}?inline=true`;
        window.open(url, '_blank');
    }

    eliminarAdjunto(id: string) {
        return http.delete(`/Catalogos/CatNomina/EliminarAdjunto/${id}`);
    }

    verAdjuntoEnNuevaPestana(id: string) {
        return http.get(`/Catalogos/CatNomina/DescargarAdjunto/${id}?inline=true`, {
            responseType: 'blob'  // ¡IMPORTANTE! Para recibir el archivo binario
        }).then(response => {
            const blob = new Blob([response.data], { type: response.data.type || 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            // Opcional: liberar memoria después de un tiempo
            setTimeout(() => window.URL.revokeObjectURL(url), 10000);
        }).catch(error => {
            console.error('Error al abrir adjunto:', error);
            alert('Error al cargar el documento');
        });
    }

    

    ObtenerUsuariosParaNomina(idSupervisor: number) {
    return http.get(`/Catalogos/CatNomina/ObtenerUsuariosParaNomina/${idSupervisor}`);
}

ConsultarEstructuraNomina() {
    return http.get(`/Catalogos/CatNomina/ConsultarEstructuraNomina`);
}



// En NominaServices.ts
GestionarEmpleadoNomina(accion: number, idSupervisor: number, idUsuario: number, soloLectura: boolean) {
    return http.post(`/Catalogos/CatNomina/GestionarEmpleadoNomina?accion=${accion}&idSupervisor=${idSupervisor}&idUsuario=${idUsuario}&soloLectura=${soloLectura}`);
}

// En src/Services/Catalogos/Nomina.ts
TransferenciaMasiva(idOrigen: number, idDestino: number, soloLectura: boolean) {
    return http.post(`/Catalogos/CatNomina/TransferenciaMasivaNomina?idOrigen=${idOrigen}&idDestino=${idDestino}&soloLectura=${soloLectura}`);
}

GestionMasivaNomina(accion: number, idOrigen: number, idDestino: number, soloLectura: boolean) {
    return http.post(`/Catalogos/CatNomina/GestionMasivaNomina?accion=${accion}&idOrigen=${idOrigen}&idDestino=${idDestino}&soloLectura=${soloLectura}`);
}

gestionarCierrePeriodo(
  accion: number,           // 1 = Cerrar periodo, 2 = Reabrir periodo
  idSupervisor: number,
  fechaInicio: string,      // formato "yyyy-MM-dd"
  fechaFin: string,         // formato "yyyy-MM-dd"
  idUsuario: number,
  motivo?: string           // opcional
) {
  let url = `/Catalogos/CatNomina/GestionarCierrePeriodo?accion=${accion}&idSupervisor=${idSupervisor}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&idUsuario=${idUsuario}`;

  // Si hay motivo, lo agregamos igual que los otros parámetros
  if (motivo && motivo.trim() !== '') {
    url += `&motivo=${encodeURIComponent(motivo.trim())}`;
  }

  return http.post(url);
}

listarPeriodosCerradoss() {
  return http.get<DTOPeriodoCerrado[]>('/Catalogos/CatNomina/ListarPeriodosCerrados');
}


listarPeriodosCerrados(inicio: string, fin: string) {
  return http.get<DTOPeriodoCerrado[]>(`/Catalogos/CatNomina/ListarPeriodosCerrados?FechaInicio=${inicio}&FechaFin=${fin}`);
}

obtenerConteoAdjuntos(fechaInicio: string, fechaFin: string) {
    return http.get(
        `/Catalogos/CatNomina/ObtenerConteoAdjuntos?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`
    );
}


}


export default new NominaServices();
